import { FilterItem } from "@/interfaces";
import { NoData } from "../no-data";
import Pagination from "../pagination";
import { SkeletonContent } from "../skeleton-content";
import { FilterBar } from "../filter-bar";

interface WrapperProps {
  children: React.ReactNode;
  length: number;
  text?: string;
  page: number;
  pageSize: number;
  total: number | null;
  setPage: (page: number) => void;
  setPageSize: (size: number) => void;
  pageSizeOptions?: number[];
  filters?: FilterItem[];
  onApply?: () => void;
  onReset?: () => void;
  loading?: boolean;
}
export default function DataWrapper(props: WrapperProps) {
  function emptyFunction() {}

  return (
    <div className="min-h-screen">
      <div className="container mx-auto">
        <FilterBar filters={props.filters || []} onReset={props.onReset || emptyFunction} />
        {props.length === 0 ? (
          <NoData text={props.text} />
        ) : (
          <>
            {props.loading ? <SkeletonContent /> : props.children}
            <Pagination
              page={props.page}
              pageSize={props.pageSize}
              total={props.total as number}
              setPage={props.setPage}
              setPageSize={props.setPageSize}
              pageSizeOptions={props.pageSizeOptions || [5, 10, 15, 20, 50, 100]}
            />
          </>
        )}
      </div>
    </div>
  );
}
